import { getHostApi } from '@/utils';
import { getLocalStorage } from '@/utils/localStorage';

export const baseUrl = (locale = '') => {
    let appInfo: any = {};
    if (typeof window !== 'undefined') {
        appInfo = getLocalStorage('appInfo') || {};
    }

    const apiObj = getHostApi(locale || appInfo.locale);
    return apiObj.NEXT_PUBLIC_API_HOST;
};

export const loginUrl = (locale?: string) => {
    let appInfo: any = {};
    if (typeof window !== 'undefined') {
        appInfo = getLocalStorage('appInfo') || {};
    }
    const apiObj = getHostApi(locale || appInfo.locale);
    return apiObj.NEXT_PUBLIC_LOGIN_HOST;
};

/** 社区模块的后端请求的API host uat 和 测试 环境默认访问 test-cloud 模仿北美 线上环境固定使用北美 */
export const getCommunityUrl = () => {
    /** uat 和 cloud 环境使用 env 配置 */
    const configUrl = process.env.NEXT_PUBLIC_COMMUNITY_HOST;
    /** 北美环境使用 login 模块的北美数据中心的URL */
    const naUrl = process.env.NEXT_PUBLIC_LOGIN_HOST;
    if (typeof configUrl === 'string' && configUrl.length > 0) {
        return configUrl;
    }
    return naUrl!;
};
